export const DRAFT_LIST = "DRAFT_LIST";
export const MESSAGE_LIST = "MESSAGE_LIST";
